import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import styles from './SubAreaDataEntry.styles';
import Select from '../../FormFields/Select';
import Text from '../../FormFields/Text';

const useStyles = makeStyles(styles);

const SubAreaDataEntry = ({ layer, options, onChange }) => {
  const classes = useStyles();
  return (<React.Fragment>
    {
      (options && options.length)
      ? options.map((option) => {
        if(option.type === "Percentage"){
          const { name, sketchSubAreaDataEntryOptionId } = option.options[0];
          return <Text
            label={name}
            value={
              (layer.sketchSubAreaDataEntryOptions && layer.sketchSubAreaDataEntryOptions.length && layer.sketchSubAreaDataEntryOptions.find(opt => opt.sketchSubAreaDataEntryOptionId === sketchSubAreaDataEntryOptionId))
              ?layer.sketchSubAreaDataEntryOptions.find(opt => opt.sketchSubAreaDataEntryOptionId === sketchSubAreaDataEntryOptionId).value
              :null
            }
            onChange={(e) => onChange(
              layer.id,
              'sketchSubAreaDataEntryOptions',
              (layer.sketchSubAreaDataEntryOptions)
              ? layer.sketchSubAreaDataEntryOptions.filter(opt => opt.type !== option.type).concat({
                sketchSubAreaDataEntryOptionId,
                type: option.type,
                value: e.target.value
                })
              : [{
                type: option.type,
                sketchSubAreaDataEntryOptionId,
                value: e.target.value
                }]
              )}
            />
        } else if(option.type === 'Single Select'){
          return <Select
            label="Single Select"
            options={option.options}
            optionValueKey={'sketchSubAreaDataEntryOptionId'}
            optionLabelKey={'name'}
            value={
              (layer.sketchSubAreaDataEntryOptions && layer.sketchSubAreaDataEntryOptions.length && layer.sketchSubAreaDataEntryOptions.find(opt => opt.type === option.type))
              ? layer.sketchSubAreaDataEntryOptions.find(opt => opt.type === option.type).sketchSubAreaDataEntryOptionId
              : null
            }
            onChange={(val) => onChange(
              layer.id,
              'sketchSubAreaDataEntryOptions',
              (layer.sketchSubAreaDataEntryOptions)
              ? layer.sketchSubAreaDataEntryOptions.filter(opt => opt.type !== option.type).concat({
                type: option.type,
                sketchSubAreaDataEntryOptionId: val,
                value: null
              })
              : [{
                type: option.type,
                sketchSubAreaDataEntryOptionId: val,
                value: null
                }]
              )}
          />;
        }
        return null;
      })
      : null
    }
  </React.Fragment>);
};
SubAreaDataEntry.defaultProps = {};
SubAreaDataEntry.propTypes = {
};

export default SubAreaDataEntry;
